import React, { createContext, useContext, useState, useCallback } from 'react';

interface ToastItem {
  id: number;
  message: string;
  type: 'error' | 'success' | 'info';
}

interface ToastContextType {
  showToast: (message: string, type?: ToastItem['type']) => void;
}

const ToastContext = createContext<ToastContextType>({ showToast: () => {} });

export const useToast = () => useContext(ToastContext);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const showToast = useCallback((message: string, type: ToastItem['type'] = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 3500);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div role="status" aria-live="polite" aria-atomic="true" style={{position:'fixed',top:'1rem',right:'1rem',zIndex:99999,display:'flex',flexDirection:'column',gap:'0.5rem',maxWidth:'24rem'}}>
        {toasts.map(toast => (
          <div
            key={toast.id}
            style={{
              padding:'0.875rem 1.25rem',
              borderRadius:'0.5rem',
              color:'white',
              fontWeight:600,
              fontSize:'0.875rem',
              boxShadow:'0 10px 15px -3px rgba(0,0,0,0.15)',
              backgroundColor: toast.type === 'error' ? '#ef4444' : toast.type === 'success' ? '#059669' : '#047857',
              animation:'slideInRight 0.3s ease-out',
              cursor:'pointer'
            }}
            onClick={() => setToasts(prev => prev.filter(t => t.id !== toast.id))}
          >
            {toast.type === 'error' ? '✕ ' : toast.type === 'success' ? '✓ ' : 'ℹ '}{toast.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

const Toast: React.FC = () => null;

export default Toast;
